import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

import { NewsApiResponse } from '../news.model';
import { NewsApiService } from '../services/news-api.service';
import { loadNews, loadNewsError, loadNewsSuccess } from './news.actions';
import { Store } from '@ngrx/store';
import { GlobalState } from '../../../store/store.model';
import { selectActiveTranslocoLangCode } from '../../../shared/language/store/language.selectors';

@Injectable()
export class NewsEffects {
  private readonly actions$ = inject(Actions);
  private readonly newsApiService = inject(NewsApiService);
  private readonly store = inject(Store<GlobalState>);

  public readonly loadNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNews),
      withLatestFrom(this.store.select(selectActiveTranslocoLangCode)),
      switchMap(([_, lang]) =>
        this.newsApiService.getNews(lang).pipe(
          map((response: NewsApiResponse) =>
            loadNewsSuccess({ news: response.news ?? [] }),
          ),
          catchError((error) =>
            of(
              loadNewsError({
                error: typeof error === 'string' ? error : 'Unable to load news.',
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
